<template>
  <div class="bq-product-tysfrzsq">
    <SectionTitle :title="'产品简介'" noSpacing></SectionTitle>
    <div class="artical">
      <p>
        单点登录（SingleSignOn，SSO）是指在多个应用系统中，用户只需要登录一次就可以访问所有相互信任的应用系统。它包括可以将这次主要的登录映射到其他应用中用于同一个用户的登录的机制。
      </p>
      <p>
        身份管理和授权管理是访问控制的前提，身份管理对用户的身份进行标识与鉴别；授权管理对用户访问资源的权限进行标识与管理。统一身份认证授权平台可以提供一次登录访问多个应用，并对其系统权限和应用权限进行统一管理。
      </p>
    </div>
    <div class="container-div">
      <div class="container">
        <div
          class="container-item"
          v-for="item in containerList"
          :key="item.advTitles"
        >
          <img class="container-item-icon" :src="item.iconUrl" />
          <div class="container-item-title">{{ item.advTitles }}</div>
          <div class="container-item-desc">{{ item.advDesc }}</div>
        </div>
      </div>
      <div class="area">
        <div class="area-title">
          单点登陆平台
        </div>
        <div class="area-content">
          <div class="content-item">
            <div class="manage-content-title">
              权限管理
            </div>
            <div class="manage-content">
              <div class="manage-desc">系统权限</div>
              <div class="manage-desc">系统角色管理</div>
              <div class="manage-desc">系统授权</div>
            </div>
          </div>
          <div class="content-item">
            <div class="manage-content-title">
              用户体系
            </div>
            <div class="manage-content">
              <div class="manage-desc1">用户管理</div>
              <div class="manage-desc1">个人中心</div>
            </div>
          </div>
          <div class="content-item">
            <div class="manage-pro-title">
              应用管理
            </div>
            <div class="manage-pro">
              <div class="manage-desc">应用角色管理</div>
              <div class="manage-desc">应用权限申请</div>
              <div class="manage-desc">应用授权</div>
              <div class="manage-desc1">应用管理</div>
              <div class="manage-desc1">应用权限管理</div>
            </div>
          </div>
          <div class="content-item">
            <div class="manage-content-title">
              接入应用
            </div>
            <div class="manage-content">
              <div class="manage-desc2">应用A</div>
              <div class="manage-desc2">应用B</div>
              <div class="manage-desc2">···</div>
              <div class="manage-desc2">应用N</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <SectionTitle :title="'产品优势'" noSpacing></SectionTitle>
    <div class="bq-advantage">
      <InfoBox
        :itemObj="item"
        :col="2"
        v-for="item in advantageList"
        :key="item.advTitles"
        :classes="'advantage'"
      ></InfoBox>
    </div>
  </div>
</template>
<script>
import SectionTitle from '@/components/website_v3/SectionTitle';
import InfoBox from '@/components/website_v3/InfoBox';

export default {
  name: 'zsygl',
  data() {
    return {
      containerList: [
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1lJuODRv0gK0jSZKbXXbK2FXa-88-84.png',
          advTitles: '开放平台',
          advDesc: '单点登录平台是一个开放的应用接入平台。',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1ig1NDUz1gK0jSZLeXXb9kVXa-90-86.png',
          advTitles: '统一管理',
          advDesc:
            '平台对接入的应用进行统一管理，包括应用的基本信息、应用菜单权限信息、应用角色信息、用户信息等。',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1qsCRDQL0gK0jSZFxXXXWHVXa-78-88.png',
          advTitles: '权限管理',
          advDesc:
            '平台用户可以对需要访问的应用进行权限申请，平台应用管理员对申请信息进行统一的审批和修改。',
        },
      ],
      advantageList: [
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB14ZCPDHr1gK0jSZFDXXb9yVXa-88-88.png',
          advTitles: '用户一致性',
          advDesc:
            '通过单点登录平台，可以统一维护一套用户信息，确保用户信息唯一性。关于卫生健康局的用户我们采用员工内部序号；而对于其他医疗机构用户，我们提供“医疗机构+工作牌号”或者“医疗机构+工作牌号员工姓名”的组合等方式来识别用户，通过程序去适配。',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1r0ePDHr1gK0jSZFDXXb9yVXa-90-92.png',
          advTitles: '方便用户',
          advDesc:
            '用户使用应用系统时，能够一次登录，多次使用。用户不再需要每次输入用户名称和用户密码，也不需要牢记多套用户名称和用户密码。单点登录平台能够改善用户使用应用系统的体验。',
        },
        {
          iconUrl:
            'https://img.alicdn.com/tfs/TB1.HmODNz1gK0jSZSgXXavwpXa-80-88.png',
          advTitles: '方便管理员',
          advDesc:
            '系统管理员只需要维护一套统一的用户账号，方便、简单。相比之下，系统管理员以前需要管理很多套的用户账号。每一个应用系统就有一套用户账号，不仅给管理上带来不方便，而且，也容易出现管理漏洞。',
        },
      ],
    };
  },
  components: {
    SectionTitle,
    InfoBox,
  },
};
</script>
<style lang="less" scoped>
@import './tysfrzsq.less';
</style>
